import { configureStore } from '@reduxjs/toolkit';

// Начальное состояние
const initialState = {
    subscriptionData: null,
    initData: null,
};

// Редюсер
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_SUBSCRIPTION_DATA':
            return {
                ...state,
                subscriptionData: action.payload,
            };
        case 'SET_INIT_DATA':
            return {
                ...state,
                initData: action.payload,
            };
        default:
            return state;
    }
};

// Создание хранилища
const store = configureStore({
    reducer,
});

export default store;